import { Check, AlertTriangle, Flag, ShieldCheck } from "lucide-react";

// Completed levels + flagged focus areas + waived skills, shared by coach and student views.
export const LevelJourney = ({ completed = [], focus = [], waived = [], audience = "coach" }) => {
  if (!completed.length && !focus.length && !waived.length) return null;
  return (
    <div className="space-y-4" data-testid="level-journey">
      {completed.length > 0 && (
        <div>
          <div className="label-mono text-[10px] text-[#A3A3A3] mb-2">COMPLETED LEVELS</div>
          <div className="flex flex-wrap gap-2">
            {completed.map((c) => {
              const adv = c.status === "completed_with_advisories";
              return (
                <span key={c.level} className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-wider px-2 py-1 border"
                  style={{ borderColor: adv ? "#FF9F1C66" : "#CCFF0066", color: adv ? "#FF9F1C" : "#CCFF00" }} data-testid={`completed-level-${c.level}`}>
                  {adv ? <AlertTriangle className="w-3 h-3" /> : <Check className="w-3 h-3" />}
                  {c.level} · {adv ? "Completed with advisories" : "Completed"}
                </span>
              );
            })}
          </div>
        </div>
      )}
      {focus.length > 0 && (
        <div data-testid="focus-areas">
          <div className="label-mono text-[10px] mb-2" style={{ color: "#FF9F1C" }}>{audience === "coach" ? "FLAGGED FOCUS AREAS" : "AREAS TO KEEP WORKING ON"}</div>
          <ul className="space-y-1">
            {focus.map((f) => (
              <li key={f.skill_id} className="text-xs text-[#E5E5E5] flex items-start gap-2" data-testid={`focus-${f.skill_id}`}>
                <Flag className="w-3 h-3 text-[#FF9F1C] mt-0.5 shrink-0" />
                <span>{f.name}{f.level ? <span className="text-[#737373]"> · {f.level}</span> : null}{audience === "coach" && f.notes ? <span className="text-[#A3A3A3] italic"> — {f.notes}</span> : null}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
      {waived.length > 0 && (
        <div data-testid="waived-skills">
          <div className="label-mono text-[10px] mb-2" style={{ color: "#60A5FA" }}>{audience === "coach" ? "WAIVED SKILLS (PERMANENT)" : "ADAPTED FOR YOUR GAME"}</div>
          <ul className="space-y-1">
            {waived.map((w) => (
              <li key={w.skill_id} className="text-xs text-[#E5E5E5] flex items-start gap-2" data-testid={`waived-${w.skill_id}`}>
                <ShieldCheck className="w-3 h-3 text-[#60A5FA] mt-0.5 shrink-0" />
                <span>{w.name}{audience === "coach" && <span className="text-[#A3A3A3] italic"> — {w.note}{w.waived_by_name ? ` (${w.waived_by_name})` : ""}</span>}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
